/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { DataModel } from '../../engine/data-model';
import { SearchTag } from '../../model/search-tag';
import { DataModelFilters } from '../../engine/data-model-filters.enum';
import { SearchManager } from './search-manager';
import { ModelProperty } from '../../engine/model-property';
import { NameValue } from '../../tool/name-value';
import { CommonUtils } from '../../tool/common-utils';

export class DrivenSearchManager extends SearchManager {
  public model: DataModel;
  public data: any;

  constructor(model: DataModel, tags?: SearchTag[]) {
    super();
    this.initModel(model);
    if (tags) {
      this.tags = tags;
    }
  }
  protected generateTags() {
    for (const prop in this.data) {
      const property = this.model.find(prop);
      const found = this.tags.find((tag) => tag.name === prop);
      if (found) {
        found.value = this.updateValue(this.data[prop], property);
      } else {
        const tag = this.generateTag(this.data, prop, property);
        this.addTag(tag);
      }
    }
  }

  protected getData() {
    return this.data;
  }

  protected updateData(tag: SearchTag) {
    void tag;
    // no need to be implemented
  }

  private initModel(model: DataModel) {
    this.model = new DataModel();
    this.model.properties = model.getProperty(DataModelFilters.showOnSearch);
  }

  private generateTag(
    data: any,
    prop: string,
    property: ModelProperty
  ): SearchTag {
    const value = this.updateValue(data[prop], property);
    const mandatory = property.searchMandatory
      ? property.searchMandatory
      : property.mandatory;
    return new SearchTag(property.id, property.title, value, mandatory);
  }

  updateValue(value: any, property: ModelProperty) {
    if (property.searchType === 'interval') {
      const start = CommonUtils.convertDateToString(value.start);
      const end = CommonUtils.convertDateToString(value.end);
      return start + ' - ' + end;
    }
    if (value instanceof Array) {
      if (value[0] instanceof Object) {
        return value.map((item) => item[property.getLabelKey()[0]]).join(', ');
      } else if (value[0] instanceof Date) {
        return value
          .map((item) => CommonUtils.convertDateToString(item))
          .join(' - ');
      } else {
        return value.join(', ');
      }
    } else {
      if (value instanceof Object) {
        return value[property.getLabelKey()[0]];
      } else if (value instanceof Date) {
        return CommonUtils.convertDateToString(value);
      } else {
        return value;
      }
    }
  }

  getFilter(): NameValue[] {
    const nameValue: NameValue[] = [];
    for (const tag of this.tags) {
      if (tag.value instanceof Date) {
        nameValue.push(
          new NameValue(tag.name, CommonUtils.convertDateToString(tag.value))
        );
      } else if (tag.value instanceof Array) {
        nameValue.push(new NameValue(tag.name, tag.value.join(',')));
      } else if (tag.value instanceof Object) {
        nameValue.push(new NameValue(tag.name, tag.value.toString()));
      } else {
        nameValue.push(new NameValue(tag.name, tag.value));
      }
    }
    return nameValue;
  }

  resetTags() {
    this.tags = [];
  }
}
